<template>
  <organisation-add
    :show="showOrganisationAdd"
    :title="'Set up an organisation to continue'"
    :closable="false"
    @added="added"
  />
</template>

<script>
import switchMixin from "@/mixins/switch";
import OrganisationAdd from "@/components/Organisation/OrganisationAdd.vue";

export default {
  name: "OrganisationEmpty",
  mixins: [switchMixin],
  components: {
    OrganisationAdd
  },
  data() {
    return {
      showOrganisationAdd: true
    };
  },
  methods: {
    added(id) {
      this.switchOrganisation(id);
      this.showOrganisationAdd = false;
    }
  }
};
</script>
